import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var formFieldComponentName = 'QuantumFormField';
export function getFormFieldUtilityClass(slot) {
    return generateUtilityClass(formFieldComponentName, slot);
}
export var formFieldClasses = generateUtilityClasses(formFieldComponentName, [
    'root',
    'label',
    'error',
    'helperText',
]);
